import React from 'react';
import L from 'leaflet';
import { renderToStaticMarkup } from 'react-dom/server';
import { getEventKindDefinition } from './eventHistoryUtils';

const PIN_SVG = (color) => `
<svg width="26" height="42" viewBox="0 0 25 41" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.5 0C5.59644 0 0 5.59236 0 12.4918C0 22.0111 12.5 41 12.5 41C12.5 41 25 22.0111 25 12.4918C25 5.59236 19.4036 0 12.5 0Z" fill="${color}" stroke="white" stroke-width="2"/>
  <circle cx="12.5" cy="12.5" r="5.25" fill="rgba(255,255,255,0.22)"/>
</svg>
`;

const iconCache = new Map();

export const getEventMapIcon = (kind) => {
  const definition = getEventKindDefinition(kind);
  const cacheKey = definition?.key || 'default';
  if (iconCache.has(cacheKey)) return iconCache.get(cacheKey);

  const Icon = definition?.Icon || null;
  const glyph = Icon ? renderToStaticMarkup(<Icon size={14} />) : '';
  const html = `
    <div class="event-marker" style="--event-color: ${definition.color}">
      ${PIN_SVG(definition.color)}
      <div class="event-marker-glyph">${glyph}</div>
    </div>
  `;

  const icon = L.divIcon({
    className: 'event-marker-icon',
    html,
    iconSize: [26, 42],
    iconAnchor: [13, 42],
    tooltipAnchor: [0, -30],
  });

  iconCache.set(cacheKey, icon);
  return icon;
};
